var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "conference_data" },
    [
      _c(
        "div",
        { staticClass: "time_block mt-2 pb-5" },
        [
          _c("date-picker", {
            attrs: {
              "value-type": "format",
              lang: _vm.d_lang,
              clearable: false,
              "first-day-of-week": 1,
            },
            on: { change: _vm.getItems },
            model: {
              value: _vm.selected_date,
              callback: function ($$v) {
                _vm.selected_date = $$v
              },
              expression: "selected_date",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-overlay",
        { attrs: { show: _vm.is_load } },
        _vm._l(_vm.items, function (conf) {
          return _c(
            "div",
            { staticClass: "conf_type" },
            [
              _c("conference_type", {
                attrs: { cur_item: conf },
                on: { change: _vm.work_item },
              }),
            ],
            1
          )
        }),
        0
      ),
      _vm._v(" "),
      _vm.selected_items.length > 0
        ? _c("div", { staticClass: "conference_info active" }, [
            _c("div", { staticClass: "fio mb-5 mt-5" }, [
              _c("div", { staticClass: "form-group" }, [
                _c(
                  "div",
                  { staticClass: "input-group flex-nowrap" },
                  [
                    _vm._m(0),
                    _vm._v(" "),
                    _c("b-form-input", {
                      staticClass: "fs-xl",
                      attrs: {
                        placeholder: "Введіть ФІО",
                        state: _vm.send_form.user_data.length > 0,
                        maxlength: "30",
                        id: "doc_title",
                        size: "sm",
                      },
                      model: {
                        value: _vm.send_form.user_data,
                        callback: function ($$v) {
                          _vm.$set(_vm.send_form, "user_data", $$v)
                        },
                        expression: "send_form.user_data",
                      },
                    }),
                  ],
                  1
                ),
              ]),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "coment form-group" },
              [
                _c("b-textarea", {
                  attrs: { rows: "5", cols: "4" },
                  model: {
                    value: _vm.send_form.comment,
                    callback: function ($$v) {
                      _vm.$set(_vm.send_form, "comment", $$v)
                    },
                    expression: "send_form.comment",
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c("div", { staticClass: "make_conf w-25" }, [
              _c(
                "button",
                {
                  staticClass:
                    "conf_select btn btn-lg btn-outline-primary waves-effect waves-themed active",
                  attrs: { type: "button", disabled: !_vm.can_send },
                  on: { click: _vm.save_reservation },
                },
                [
                  _c("span", {
                    staticClass: "fal mr-1",
                    class: {
                      "fa-check": _vm.can_send,
                      "fa-exclamation-triangle": !_vm.can_send,
                    },
                  }),
                  _vm._v("\n                Забронювати\n            "),
                ]
              ),
            ]),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("conference_modal", { on: { reload: _vm.getItems } }),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "input-group-prepend" }, [
      _c("span", { staticClass: "input-group-text" }, [
        _c("i", { staticClass: "fal fa-user fs-xl" }),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }